import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

class ModuleTypeStore extends ReduceStore {

    getInitialState() {
        return [];
    }

    getAll() {
        return this.getState().slice();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.MODULE_TYPE_LIST_SUCCESS:
                return action.data.slice();

            default:
                return state;
        }
    }
}

export default new ModuleTypeStore(CentricDispatcher);
